export const globalController = new AbortController();
export const globalAbortSignal = globalController.signal;

export function resetController() {
    globalController.abort();
    // Note: You can't reuse an aborted controller, so this is mainly for cleanup
}